import { MINUTE_MS, parseDbTime } from "@nexus/widget-kit";
import { createDateFormatter, type TimezoneMode } from "@nexus/ui";

const compact = new Intl.NumberFormat(undefined, { notation: "compact", maximumFractionDigits: 1 });

export const formatCount = (value: number | null) => (value === null ? "—" : compact.format(value));

export const formatPercent = (value: number | null) =>
  value === null ? "—" : `${Math.round(value * 100)}%`;

export function formatDateTime(value: string | null | undefined, timezone: TimezoneMode = "utc") {
  const time = value ? parseDbTime(value) : NaN;
  return Number.isFinite(time)
    ? createDateFormatter(timezone, {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(time)
    : "—";
}

/** "1h 05m" — compact durations read faster than clock ranges. */
export function formatSpan(ms: number) {
  const minutes = Math.max(0, Math.round(ms / MINUTE_MS));
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours}h ${String(rest).padStart(2, "0")}m` : `${hours}h`;
}

export function formatAgo(time: number, now: number) {
  return Number.isFinite(time) && Number.isFinite(now) ? `${formatSpan(now - time)} ago` : "—";
}

/** Share of the broadcast window already elapsed, 0–100. */
export function elapsedPercent(start: string, end: string, now: number) {
  const from = parseDbTime(start);
  const to = parseDbTime(end);
  return Number.isFinite(from) && to > from
    ? Math.min(100, Math.max(0, ((now - from) / (to - from)) * 100))
    : 0;
}
